
export default function cloudinaryVideoModal() {

  document.querySelectorAll('.launch-cloudinary-video').forEach(el => {

    el.addEventListener('click', function (e) {
      console.log('cloudinary video click');

      e.preventDefault();


      var player = document.getElementById('cloudinary-video-player');
      player.setAttribute('src', this.href);


      document.getElementById('cloudinaryModal').classList.add('open');

      document.querySelectorAll('body').forEach(el => {
        el.classList.add('modal-open');
      });
    });
  });


  document.querySelectorAll('.cloudinary-video-modal__content-wrap').forEach(el => {
    el.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });



  document.querySelectorAll('.cloudinary-video-modal').forEach(el => {
    el.addEventListener('click', function (e) {
      e.stopPropagation();

      el.classList.remove('open');
      el.classList.add('fade-out');

      var player = document.getElementById('cloudinary-video-player');
      player.setAttribute('src', '');

      document.querySelectorAll('body').forEach(el => {
        el.classList.remove('modal-open');
      });
    });
  });




}
